import React from "react";
import { Box, ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import theme from "../theme/theme";
import "./styles/style.css";
import NotificationMessage from "components/NotificationMessage";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { hideMessage } from "appRedux/actions/Notification";
import Footer from "components/Footer/Footer";

/* export const MainLayout = ({ children }) => {
  const { messages } = useSelector((store) => store.notification, shallowEqual);
  const dispatch = useDispatch();

  const renderMessages = () => {
    return (
      <>
        {messages.map(({ id, ...rest }) => (
          <NotificationMessage
            {...rest}
            key={`msg-${id}`}
            id={id}
            cleanerAction={(id) => {
              dispatch(hideMessage(id));
            }}
          />
        ))}
      </>
    );
  };

  return (
    <ChakraProvider theme={theme}>
      {renderMessages()}
      {children}
      <Footer />
    </ChakraProvider>
  );
}; */

/* export const MainLayout = ({ children }) => {
  const { messages } = useSelector((store) => store.notification, shallowEqual);
  const dispatch = useDispatch();

  return (
    <ChakraProvider theme={theme}>
      <Box h="100vh" overflow="hidden" display="flex" flexDir="column">
        {messages.map(({ id, ...rest }) => (
          <NotificationMessage
            {...rest}
            key={`msg-${id}`}
            id={id}
            cleanerAction={() => dispatch(hideMessage(id))}
          />
        ))}

        <Box flex="1" overflow="hidden">
          {children}
        </Box>

        <Footer />
      </Box>
    </ChakraProvider>
  );
}; */

export const MainLayout = ({ children }) => {
  const { messages } = useSelector((store) => store.notification, shallowEqual);
  const dispatch = useDispatch();

  return (
    <Box minH="100vh" display="flex" flexDir="column">
      {messages.map(({ id, ...rest }) => (
        <NotificationMessage
          {...rest}
          key={`msg-${id}`}
          id={id}
          cleanerAction={() => dispatch(hideMessage(id))}
        />
      ))}

      <Box flex="1">{children}</Box>
    </Box>
  );
};
